import type { PageEnvelope } from "@skv/core";
import * as React from "react";

export const defaultPageEnvelopeState = {
  success: false,
  data: null,
  errorCode: null,
  errorMessage: null,
  meta: null,
};

declare const window: {
  pageEnvelope: any;
};

export const PageEnvelopeStateContext = React.createContext<
  PageEnvelope<undefined> | undefined
>(defaultPageEnvelopeState);

export const PageEnvelopeProvider: React.FC<{
  initialPageEnvelope: PageEnvelope<any>;
}> = ({ initialPageEnvelope, children }) => {
  const [state, setState] = React.useState(
    initialPageEnvelope || defaultPageEnvelopeState
  );

  const resetPageEnvelope = React.useCallback(() => {
    setState(defaultPageEnvelopeState);
  }, []);

  React.useEffect(() => {
    window.pageEnvelope = initialPageEnvelope;
    resetPageEnvelope();
  }, []);

  return (
    <PageEnvelopeStateContext.Provider value={state}>
      {children}
    </PageEnvelopeStateContext.Provider>
  );
};

export const usePageEnvelope = <T,>(): {
  pageEnvelope: PageEnvelope<T>;
} => {
  const state = React.useContext(PageEnvelopeStateContext);

  /* Page envelope gets reset, so we store the initial value of pageEnvelope in a localised state before the context gets reset */
  const memorizedState = React.useMemo(() => {
    return state;
  }, []);

  return {
    pageEnvelope: memorizedState,
  };
};

export default PageEnvelopeProvider;
